import * as React from 'react';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';
import PermissionsOverviewContainer from '~/containers/Permissions/PermissionsOverview';

const AuthorityPage = () => (
  <>
    <PermissionsOverviewContainer />
  </>
);

export default dashboardWrapper(AuthorityPage, t('menu.dashboard.authority'));
